import React from "react"
import {
  AlertOutlined,
  ApartmentOutlined,
  AppstoreOutlined,
  BarChartOutlined,
  BookOutlined,
  ExperimentOutlined,
  FileTextOutlined,
  HomeOutlined,
  SafetyCertificateOutlined,
  SettingOutlined,
  TeamOutlined,
  ToolOutlined,
  WarningOutlined
} from "@ant-design/icons"

/** Map iconKey → Ant Design icon (sidebar EES). */
export const MENU_ICONS = {
  home: <HomeOutlined />,
  project: <ApartmentOutlined />,
  ops: <FileTextOutlined />,
  daily: <FileTextOutlined />,
  water: <ExperimentOutlined />,
  incident: <WarningOutlined />,
  asset: <ToolOutlined />,
  equipment: <ToolOutlined />,
  maint: <SettingOutlined />,
  stock: <AppstoreOutlined />,
  chem: <ExperimentOutlined />,
  alert: <AlertOutlined />,
  report: <BarChartOutlined />,
  settings: <SettingOutlined />,
  catalog: <BookOutlined />,
  compliance: <SafetyCertificateOutlined />,
  staff: <SafetyCertificateOutlined />,
  user: <TeamOutlined />,
  role: <SafetyCertificateOutlined />
}

export function resolveMenuIcon(iconKey) {
  if (!iconKey) return null
  return MENU_ICONS[iconKey] || null
}
